import cn from "classnames";
import { createBemBlockBuilder } from "@ebsco-ui/utils";
import AccordionSection, {
  AccordionSectionProps,
  Section,
} from "./accordion-section";

import "./accordion.scss";

export interface AccordionProps {
  className?: string;
  items: Section[];
  renderSection: AccordionSectionProps["renderSection"];
  renderCollapseTitle?: AccordionSectionProps["renderCollapseTitle"];
  disableAnimations?: AccordionSectionProps["disableAnimations"];
  expandAllSections?: boolean;
  renderExpandTitle?: AccordionSectionProps["renderExpandTitle"];
  onClick?: AccordionSectionProps["onClick"];
  openSections?: { [id: string]: boolean };
  selectedId?: string | null;
  topLevel?: AccordionSectionProps["topLevel"];
  collapseTitle?: AccordionSectionProps["collapseTitle"];
  expandTitle?: AccordionSectionProps["expandTitle"];
}

// Ripped from here https://alligator.io/react/react-accordion-component/
// and here https://codesandbox.io/s/p51vxkr7j
export const Accordion = ({
  className,
  collapseTitle = "",
  disableAnimations = false,
  expandAllSections = false,
  expandTitle = "",
  items,
  onClick = () => {},
  openSections = {},
  renderCollapseTitle = () => "",
  renderExpandTitle = () => "",
  renderSection,
  selectedId = "",
  topLevel = false,
}: AccordionProps) => {
  const getBlocksWith = createBemBlockBuilder([className, "eb-accordion"]);

  const renderSubSections = (subSections: Section[]) => {
    return (
      subSections &&
      subSections.length > 0 && (
        <Accordion
          className={className}
          renderCollapseTitle={renderCollapseTitle}
          collapseTitle={collapseTitle}
          disableAnimations={disableAnimations}
          expandAllSections={expandAllSections}
          renderExpandTitle={renderExpandTitle}
          expandTitle={expandTitle}
          items={subSections}
          onClick={onClick}
          openSections={openSections}
          renderSection={renderSection}
          selectedId={selectedId}
        />
      )
    );
  };

  return (
    <div
      className={cn(getBlocksWith(), topLevel && getBlocksWith("--top-level"))}
    >
      {items &&
        items.length &&
        items.map((section) => {
          const { id, subSections } = section;
          return (
            <AccordionSection
              getBlocksWith={getBlocksWith}
              renderCollapseTitle={renderCollapseTitle}
              collapseTitle={collapseTitle}
              disableAnimations={disableAnimations}
              renderExpandTitle={renderExpandTitle}
              expandTitle={expandTitle}
              isOpen={expandAllSections || !!openSections[id]}
              isSelected={id === selectedId}
              key={id}
              onClick={onClick}
              renderSection={renderSection}
              section={section}
              showToggleButtons={!expandAllSections}
              topLevel={topLevel}
            >
              {renderSubSections(subSections)}
            </AccordionSection>
          );
        })}
    </div>
  );
};

export default Accordion;
